// ============================================================================
// seedCarimbo: assinatura (updatedAt) dos dados de demonstração (seed).
// ============================================================================
// 23/10/2026 (rodada 2, item 1). Nenhuma edição de verdade tem estes carimbos:
//   - '2024-01-01T00:00:00.000Z': carimbo fixo do seed atual (src/data/seedData.js);
//   - '2026-04-14T20:07:36.762Z': lote de 310 dias do seed visto no backup de 09/06;
//   - '2026-09-05T15:23:29.5…': lote de 05/09 (cópia velha do código com o carimbo
//     new Date() na carga do módulo), em fk_daily_revenue, fk_unit_metas e fk_unit_config.
// Espelho do servidor: api/_lib/data-merge.js (um teste confere que as listas são iguais).
// Puro: sem imports.
// ============================================================================

export const CARIMBOS_SEED_EXATOS = ['2024-01-01T00:00:00.000Z', '2026-04-14T20:07:36.762Z'];
export const CARIMBOS_SEED_PREFIXOS = ['2026-09-05T15:23:29.5'];

export function ehCarimboSeed(updatedAt) {
  if (typeof updatedAt !== 'string' || !updatedAt) return false;
  if (CARIMBOS_SEED_EXATOS.includes(updatedAt)) return true;
  return CARIMBOS_SEED_PREFIXOS.some(p => updatedAt.startsWith(p));
}
